/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Which PDF flavor to attach
 */

export const ProcessOfferEmailVariantDto = {
    Offer: 'OFFER',
    RealizationOffer: 'REALIZATION_OFFER',
} as const;

export type ProcessOfferEmailVariantDto = typeof ProcessOfferEmailVariantDto[keyof typeof ProcessOfferEmailVariantDto];



